import { useState } from 'react';
import NavBar from './NavBar';
import SideBar from './SideBar';
import QuickStrategyModal from '../QuickStrategy/QuickStrategyModal';
import StrategyRecommendationModal from '../../private/Strategies/StrategyRecommendationModal';
import GridAIModal from '../GridAI/GridAIModal';
import Toast from '../Toast';

function Menu() {
    const [notification, setNotification] = useState({ type: '', text: '' });

    return (
        <>
            <NavBar />
            <SideBar />
            <QuickStrategyModal onNotification={setNotification} />
            <StrategyRecommendationModal onNotification={setNotification} />
            <GridAIModal onNotification={setNotification} />
            <Toast type={notification.type} text={notification.text} enableSocket />
        </>
    )
}

export default Menu;
